import { useEffect, useState } from "react";
import { Card, Table, Switch, Space, Button, Tag, message } from "antd";
import { Link } from "react-router-dom";
import { listIntegrationHealthApi } from "../api/admin.workspaces.api";

function IntegrationHealth() {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [filters, setFilters] = useState({
    onboarding_incomplete: false,
    reauth_required: false,
    sync_error: false,
  });

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await listIntegrationHealthApi({
        ...filters,
        page_size: 100,
      });
      if (res.data.status === "success") {
        const data = res.data.data || {};
        setRows((data.rows || []).map((r, i) => ({ ...r, key: `${r.workspace_id}-${r.property_id}-${i}` })));
      } else {
        message.error(res.data.message);
      }
    } catch (e) {
      message.error("Failed to load integration health");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [filters]);

  const columns = [
    {
      title: "Workspace",
      dataIndex: "workspace_name",
      render: (name, r) => (
        <Link to={`/workspaces/${r.workspace_id}`}>{name}</Link>
      ),
    },
    { title: "Owner", dataIndex: "owner_email" },
    { title: "Property", dataIndex: "property_name" },
    { title: "Website", dataIndex: "website_url", ellipsis: true },
    {
      title: "GA4",
      dataIndex: "ga4_status",
      render: (s, r) => (
        <Space direction="vertical" size={0}>
          <Tag>{s || "none"}</Tag>
          {r.ga4_error ? <small>{r.ga4_error}</small> : null}
        </Space>
      ),
    },
    { title: "Replay", dataIndex: "replay_status", render: (s) => <Tag>{s || "none"}</Tag> },
    { title: "Entitlement", dataIndex: "entitlement_status" },
    { title: "Onboarding", dataIndex: "onboarding_status" },
  ];

  return (
    <div className="layout-content">
      <Card
        title="Integration health"
        extra={<Button onClick={fetchData}>Refresh</Button>}
      >
        <Space style={{ marginBottom: 16 }} wrap>
          <span>Onboarding incomplete</span>
          <Switch
            checked={filters.onboarding_incomplete}
            onChange={(v) => setFilters((f) => ({ ...f, onboarding_incomplete: v }))}
          />
          <span>Reauth required</span>
          <Switch
            checked={filters.reauth_required}
            onChange={(v) => setFilters((f) => ({ ...f, reauth_required: v }))}
          />
          <span>Sync error</span>
          <Switch
            checked={filters.sync_error}
            onChange={(v) => setFilters((f) => ({ ...f, sync_error: v }))}
          />
        </Space>
        <Table loading={loading} columns={columns} dataSource={rows} pagination={{ pageSize: 20 }} />
      </Card>
    </div>
  );
}

export default IntegrationHealth;
